import { useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

export function useEsgMatricesLookup() {
    const queryClient = useQueryClient()

    return useQuery({
        queryKey: ['clientesglookup'],
        queryFn: async ({ signal }) => {
            try {
                const base = process.env.REACT_APP_API_URL || process.env.REACT_APP_BASE_SERVER || ''
                const trimmedBase = base.replace(/\/$/, '')
                const url = `${trimmedBase}/client-esg-lookup`

                const response = await axios({
                    url: url,
                    method: 'GET',
                    withCredentials: true,
                    signal,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                })

                return response?.data?.data ?? []
            } catch (error) {
                console.error('Error details:', {
                    message: error.message,
                    status: error?.response?.status,
                    statusText: error?.response?.statusText,
                    data: error?.response?.data,
                    url: error?.config?.url
                })

                if (error?.response?.status === 401) {
                    queryClient.invalidateQueries({
                        queryKey: ['session-lookup'],
                    })
                }

                throw {
                    message: error?.response?.data?.message || error.message,
                    status: error?.response?.status,
                    statusText: error?.response?.statusText,
                    url: error?.config?.url
                }
            }
        },
        initialData: [],
        retry: false,
    })
}


export function useEsgMatricesSummaryLookup() {
  return useQuery({
    queryKey: ['clientesgmatricessummarylookup'],
    retry: false,
    queryFn: async ({ signal }) => {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SERVER}/client-esg-matrices-summary-lookup`,
        method: 'GET',
        withCredentials: true,
        signal,
      })
      return response.data ?? {}

    },
  })
}
